export default __webpack_public_path__ + "static/media/cook7.c7cf3fb4.png";